module.exports = __webpack_public_path__ + "b70e186c.png";